import API from "../api/manager";
import config from "../api/config";

const LONG_TIMEOUT_MS = 180000;

/** Step 1: extract the uploaded e-stamp. Nothing is saved; returns { report, confirm_data }. */
const preview = (data) => {
  return API({
    method: "POST",
    url: config.urls.estamp.preview,
    data,
    timeout: LONG_TIMEOUT_MS,
  });
};

/** Step 2: save the previewed e-stamp; send confirm_data from the preview as-is. */
const confirm = (data) => {
  return API({
    method: "POST",
    url: config.urls.estamp.confirm,
    data,
    timeout: LONG_TIMEOUT_MS,
  });
};

/** data: { partyId, count, documentFile, excelFile, first_party, second_party } */
const splitBatch = (data) => {
  return API({
    method: "POST",
    url: config.urls.estamp.splitBatch,
    data,
    timeout: LONG_TIMEOUT_MS,
  });
};

const jobStatus = (id) => {
  return API({
    method: "GET",
    url: config.urls.estamp.jobStatus(id),
  });
};

const partyStock = (partyId) => {
  return API({
    method: "GET",
    url: config.urls.estamp.partyStock(partyId),
  });
};

export default { preview, confirm, splitBatch, jobStatus, partyStock };
